export default __webpack_public_path__ + "static/media/team-logo.11aaedad.png";